<template>
  <div id="ms_header_downside" class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div id="corp_information">
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section id="president_msg">
            <h2>代表メッセージ</h2>
            <div>
              <!-- <div>
                <img :src="getImage('common/noimage.png')">
                <div>mm/style運営企業</div>
                <div>ドゥーマンズ株式会社</div>
                <div>代表 二宮 健一</div>
              </div> -->
              <p>
                私たちが考える。新しい家具のカタチ。<br>
                <br>
                日本のポンペイともいえる鳥取県・青谷上寺地遺跡からは、約2000年前に使われた木製建具や収納等の住宅設備が、当時のまま発掘されています。<br>
                <br>
                丸太を意のままに割り、機能とフィルムを一体化させた創造性あふれる造形には、弥生人の生活に対する豊かな人間性が感じられます。<br>
                <br>
                時は流れ、工業製品による「豊かさ」や「便利さ」を享受する現在社会。
                家具や日用品の物量は爆発的に増え、量産品の激しい価格競争によって、本当に「価値のあるモノ」や「価値のあるコト」が見えにくい世の中になっていると感じています。
                「もっと自分らしく快適な部屋で暮らしたい」「もっと自由に家族のライフスタイルを表現したい」<br>
                <br>
                それは誰もが持っている普遍的な欲求だと思います。収納が自由になると住み心地は劇的に変わります。収納とはその部屋での生活を快適にするために欠かせない住宅設備なのです。<br>
                <br>
                寸法も、色素材も、引き出しも扉も、自由にプランできて、しかも低価格。私たちが提供したいのは、生活を支える「道具」と、それを手に入れる「仕組み」です。
                家族のみんなが、そのストーリーを刻める、新しい「家具のカタチ」が始まります。
              </p>
            </div>
          </section>
          <section>
            <h2>運営会社概要</h2>
            <ul class="ul_corp_outline">
              <li>
                <div>商号</div>
                <div>ドゥーマンズ株式会社 Domans, Inc.</div>
              </li>
              <li>
                <div>所在地</div>
                <div>東京都渋谷区代々木 3-28-6 いちご西参道ビル １階</div>
              </li>
              <li>
                <div>設立日</div>
                <div>2000年6月26日</div>
              </li>
              <li>
                <div>電話番号</div>
                <div>03-5354-7671</div>
              </li>
              <li>
                <div>資本金</div>
                <div>2億5733万円（2020年12月末日現在）決算期 12月</div>
              </li>
              <li>
                <div>代表者</div>
                <div>二宮 健一</div>
              </li>
              <li>
                <div>主要株主</div>
                <div>
                  経営陣<br>
                  K&Pパートナーズ株式会社<br>
                  株式会社キャンディル<br>
                  三菱UFJキャピタル株式会社
                </div>
              </li>
              <li>
                <div>主な事業内容</div>
                <div>
                  1. 製造連携システムのクラウドライセンス事業<br>
                  2. 製造連携システムのカスタマイズライセンス事業
                </div>
              </li>
              <li>
                <div>主要取引先</div>
                <div>
                  ・株式会社ウッドワン<br>
                  ・柏木工株式会社<br>
                  ・住友林業クレスト株式会社<br>
                  ・株式会社TJMデザイン<br>
                  ・パナソニック建設エンジニアリング株式会社<br>
                  ・株式会社LIXIL<br>
                  ・その他<br>
                  (五十音順・敬称略)
                </div>
              </li>
              <li>
                <div>許認可、<br>及び所属団</div>
                <div>
                  経済産業省 関東経済業局 新連携対策補助金支援事業<br>
                  東京建具協同組合<br>
                  公益社団法人インテリア産業協会<br>
                  キッチン・バス工業会<br>
                  東京家具工業組合
                </div>
              </li>
              <li>
                <div>関係会社</div>
                <div>
                  ファニチャーメーカー株式会社<br>
                  資本金：1,500万円<br>
                  事業内容：オーダー家具製造販売事業
                </div>
              </li>
            </ul>
          </section>
          <section>
            <h2>アクセス</h2>
            <p>
              東京都渋谷区代々木 3-28-6 いちご西参道ビル １階<br>
              都営地下鉄新宿線「初台」駅より徒歩8分<br>
              <br>
              Tel: 03-5354-7671<br>
              Fax: 03-5354-7672<br>
              フリーダイヤル: 0800-888-9955
            </p>
            <div id="gmap">
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12962.952115184788!2d139.691904!3d35.683452!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6b97f71ea432901e!2z44OJ44Kl44O844Oe44Oz44K6!5e0!3m2!1sja!2sjp!4v1634889030888!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'

import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcCorpInformation',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'corpInformation', key: 'dcCorpInformation', title: '会社案内', route: 'DcCorpInformation'}
      ]
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcCorpInformation.vue